var React = require('react');

function Check (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.16669 8.5L6.46652 11.7998L13.5376 4.72876","stroke":"currentColor","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

Check.defaultProps = {"width":"17","height":"17","viewBox":"0 0 17 17","fill":"none"};

module.exports = Check;

Check.default = Check;
